<template>
  <div>
    <home-swiper></home-swiper>
    <home-notice></home-notice>
    <div class="main-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card :body-style="{ padding: '0px' }">
            <div slot="header" class="box-card-header">
              <span>场馆分布</span>
            </div>
            <baidu-map class="bm-view" :center="{lng: 114.933266, lat: 30.455736}" :zoom="16">
              <bm-point-collection :points="points" shape="BMAP_POINT_SHAPE_RHOMBUS" color="red"
                                   size="BMAP_POINT_SIZE_BIGGER">
              </bm-point-collection>
            </baidu-map>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header" class="box-card-header">
              <span>热点新闻</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click.native="toNews">更多<sup>+</sup>
              </el-button>
            </div>
            <div class="home-container-style-1">
              <div class="news-list">
                <div class="list-item" v-for="(item,index) in newsList" :key="index" v-on:click="toNewsDetail(item.id)">
                  <span class="date">[{{item.publishDate}}]</span>{{item.title}}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header" class="box-card-header">
              <span>场馆预约</span>
            </div>
            <div class="home-container-style-1">
              <img src="static/images/common/appointment.png" width="100%" height="100%"/>
              <div style="text-align: center">
                <el-button type="primary" size="medium " @click.native="onGenerateQrcode">生成预约二维码</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- <home-content></home-content>
     <teacher-style></teacher-style>-->
    <div class="main-container margin-gap-v">
      <el-card>
        <div slot="header" class="box-card-header">
          <span>名师风采</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in partnersList" :key="index">
            <el-card class="partner-container">
              <div class="img-container">
                <img :src="item.portrait">
              </div>
              <div class="info">{{item.name}}</div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <appoiment-qr-code ref="appoimentQrcode"></appoiment-qr-code>
  </div>
</template>
<script>
  import TopHeader from 'src/components/TopHeader'
  import TopNav from 'src/components/TopNav'
  import BottomFooter from 'src/components/BottomFooter'
  import HomeSwiper from './component/HomeSwiper'
  import HomeNotice from './component/HomeNotice'
  import AppoimentQrCode from 'src/components/AppoimentQrCode'
  import {news} from 'src/api/stadiumApi'
  import {partners} from 'src/api/trainingApi'
  import {IMAGE_BASE_URL} from 'src/config/pathConfig'

  export default {
    name: 'home',
    components: {
      TopHeader,
      TopNav,
      BottomFooter,
      HomeSwiper,
      HomeNotice,
      AppoimentQrCode
    },
    data () {
      return {
        points: [],
        newsList: [],
        partnersList: []
      }
    },
    computed: {},
    mounted () {
      this.$nextTick(function () {
        this.addPoints()
        this.onLoadNews()
        this.onLoadNewsPartners()
      })
    },
    methods: {
      addPoints () {
        let points = []
        points.push({lng: 114.933266, lat: 30.455736})
        points.push({lng: 114.933728, lat: 30.451374})// 乒乓球馆
        points.push({lng: 114.935399, lat: 30.44888})// 体育馆,
        this.points = points
      },
      onLoadNews () {
        news(null, 1, 5).then((resp) => {
          this.newsList = resp.content
        })
      },
      onLoadNewsPartners () {
        partners().then((resp) => {
          this.partnersList = []
          for (var i = 0; i < resp.length; i++) {
            let partner = resp[i]
            this.partnersList.push({
              portrait: IMAGE_BASE_URL + partner.portrait,
              name: partner.name
            })
          }
        })
      },
      toNews () {
        this.$router.push({
          name: 'News'
        })
      },
      toNewsDetail (id) {
        this.$router.push({
          name: 'NewsDetail',
          query: {
            id: id
          }
        })
      },
      onGenerateQrcode () {
       this.$router.push({
          name: 'Appointment'
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue